import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, of, tap } from 'rxjs';
import { FeatureSettings } from './settings.state';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly SETTINGS_URI = `${environment.adventureUri}/feature-settings`;

  private featureSettings: FeatureSettings;

  constructor(private http: HttpClient) {}

  public loadFeatureSetttings(): Observable<FeatureSettings> {

    if (this.featureSettings) {
      return of(this.featureSettings);
    }

    return this.http
      .get<FeatureSettings>(`${this.SETTINGS_URI}`)
      .pipe(tap(featureSettings => { this.featureSettings = featureSettings }));
  }
}
